/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Styles from './DenFraudesBoletoSeguro.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function DenFraudesBoletoSeguro() {
  return (
    <>
      <section id="den-fraudes-boleto-seguro">
        <ContainerHome24>
          <h3 className="boleto-seguro-titulo">Boleto seguro</h3>
          <p className="boleto-seguro-subtitulo">
            Dicas de como você pode garantir que gerou ou recebeu um boleto verdadeiro:
          </p>
          <div className="boleto-seguro-cards">
            <div className="boleto-seguro-card">
              <div className="boleto-seguro-card-titulo">
                <img src="assets/denuncias-e-fraudes/ic_email.svg" alt="icone email" />
                <p className="boleto-seguro-card-titulo-texto">E-mail</p>
              </div>
              <p className="boleto-seguro-card-texto">
                Se o boleto foi enviado pelo email sitesantander@santander.com.br
              </p>
            </div>
            <div className="boleto-seguro-card">
              <div className="boleto-seguro-card-titulo">
                <img src="assets/denuncias-e-fraudes/ic_internet_banking.svg" alt="icone banking" />
                <p className="boleto-seguro-card-titulo-texto">Área do Cliente</p>
              </div>
              <p className="boleto-seguro-card-texto">
                Se gerou o boleto pelo site santanderfinanciamentos.com.br
              </p>
            </div>

            <div className="boleto-seguro-card extendido">
              <div className="boleto-seguro-card-titulo">
                <img src="assets/denuncias-e-fraudes/ic_phone.svg" alt="icone telefone" />
                <p className="boleto-seguro-card-titulo-texto">Telefone</p>
              </div>
              <p className="boleto-seguro-card-texto">
                Se entrou em contato pelo telefone 4004-9090 (regiões metropolitanas) ou 0800 722
                9090 (demais localidades).
              </p>
            </div>
            <div className="boleto-seguro-card">
              <div className="boleto-seguro-card-titulo">
                <img src="assets/denuncias-e-fraudes/ic_mobile.svg" alt="icone mobile" />
                <p className="boleto-seguro-card-titulo-texto">Aplicativo</p>
              </div>
              <p className="boleto-seguro-card-texto">
                Se gerou o boleto pelo aplicativo Santander Financiamentos.
              </p>
            </div>
            <div className="boleto-seguro-card">
              <div className="boleto-seguro-card-titulo">
                <img src="assets/denuncias-e-fraudes/ic_email.svg" alt="icone whatsapp" />
                <p className="boleto-seguro-card-titulo-texto">WhatsApp</p>
              </div>
              <p className="boleto-seguro-card-texto">
                Se consultou informações de boleto pelo Whatsapp no número <br />
                4004-9090.
              </p>
            </div>
            <div className="boleto-seguro-card extendido">
              <div className="boleto-seguro-card-titulo">
                <img src="assets/denuncias-e-fraudes/ic_internet_banking.svg" alt="icone boleto" />
                <p className="boleto-seguro-card-titulo-texto">Débito automático</p>
              </div>
              <p className="boleto-seguro-card-texto">
                Pague seu financiamento com débito em conta e garanta sua segurança.
              </p>
            </div>
          </div>

          <div className="boleto-seguro-denuncia">
            <h4 className="boleto-seguro-titulo-denuncia">Canal de denúncia</h4>
            <p className="boleto-seguro-subtitulo-denuncia">
              Encontrou algum site suspeito, está recebendo contatos de um Whatsapp desconhecido?{' '}
              <br />
              Entre em contato conosco <br /> pelo e-mail:{' '}
              <a href="mailto:suspeita@santander.com.br">suspeita@santander.com.br</a>
            </p>
          </div>
        </ContainerHome24>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default DenFraudesBoletoSeguro;
